"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var ErrorWithMessage = function (props) {
    var _a = (0, react_1.useState)(props.error), error = _a[0], setError = _a[1];
    (0, react_1.useEffect)(function () {
        return function () {
            setError("");
        };
    }, []);
    (0, react_1.useEffect)(function () {
        setError(props.error);
        setTimeout(function () {
            setError("");
        }, 10000);
    }, [props]);
    return (React.createElement("div", { className: "mt-5 text-center" },
        React.createElement("h5", { className: "error-text" }, error),
        props.apiCall && (React.createElement("button", { className: "btn-base-lg delete-btn-lg mt-5", onClick: props.apiCall }, "Retry"))));
};
exports.default = ErrorWithMessage;
